export default "__VITE_ASSET__CrEqRCXr__"